import { useTranslation } from 'react-i18next';

const featureKeys = [
  {
    key: 'features.gitBranching',
    color: 'text-cyan-400',
    bg: 'bg-cyan-500/10',
    borderColor: 'border-l-cyan-500/40',
    icon: (
      <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" />
      </svg>
    ),
  },
  {
    key: 'features.aiTranslation',
    color: 'text-amber-400',
    bg: 'bg-amber-500/10',
    borderColor: 'border-l-amber-500/40',
    icon: (
      <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.455 2.456L21.75 6l-1.036.259a3.375 3.375 0 00-2.455 2.456z" />
      </svg>
    ),
  },
  {
    key: 'features.glossary',
    color: 'text-rose-400',
    bg: 'bg-rose-500/10',
    borderColor: 'border-l-rose-500/40',
    icon: (
      <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
      </svg>
    ),
  },
  {
    key: 'features.cliWorkflow',
    color: 'text-emerald-400',
    bg: 'bg-emerald-500/10',
    borderColor: 'border-l-emerald-500/40',
    icon: (
      <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="m6.75 7.5 3 2.25-3 2.25m4.5 0h3m-9 8.25h13.5A2.25 2.25 0 0021 18V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v12a2.25 2.25 0 002.25 2.25z" />
      </svg>
    ),
  },
];

export default function Features() {
  const { t } = useTranslation();

  return (
    <section id="features" className="border-t border-slate-800/50">
      <div className="mx-auto max-w-6xl px-6 py-20 md:py-28">
        <div className="text-center">
          <h2 className="font-display text-3xl font-bold tracking-tight md:text-4xl">
            {t('features.heading')}
          </h2>
          <p className="mt-4 text-slate-400">
            {t('features.subheading')}
          </p>
        </div>

        <div className="mt-14 grid gap-8 sm:grid-cols-2">
          {featureKeys.map((f) => (
            <div
              key={f.key}
              className={`rounded-2xl border border-slate-800/80 border-l-2 ${f.borderColor} bg-slate-900/50 p-6 transition-colors hover:border-slate-700 hover:${f.borderColor}`}
            >
              <div className={`flex h-10 w-10 items-center justify-center rounded-xl ${f.bg} ${f.color}`}>
                {f.icon}
              </div>
              <h3 className="mt-4 font-display text-lg font-semibold">{t(`${f.key}.title`)}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-400">
                {t(`${f.key}.description`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
